import React, { useEffect } from "react";
import LeftSideNavigation from "../../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import { Button, Col, Row, Form } from "react-bootstrap";
import { TextField } from "@material-ui/core";
import { useFormik } from "formik";
import * as yup from "yup";
import { connectAdvanced, useDispatch, useSelector } from "react-redux";
import {
  add_page,
  edit_page,
  get_pages,
  get_single_page,
} from "../../../../../store/actions/Experience/adminExperienceAction";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { errorAlert, successAlert } from "../../../../../function/alert";
import { useParams } from "react-router-dom";

const validationSchema = yup.object({
  page_id: yup
    .number()
    .typeError("Page ID should be a number")
    .required("Page ID is required."),
  description: yup.string().required("Descripion is required."),
  position: yup
    .number()
    .typeError("Position should be a number")
    .required("Position is required."),
});

const Addpages = () => {
  const { page_id } = useParams();
  const dispatch = useDispatch();
  const history = useHistory();
  const auth = useSelector((state) => state.auth);
  const pages = useSelector((state) => state.superAdminExperience.pages);

  useEffect(() => {
    if (page_id) {
      dispatch(
        get_single_page(auth?.user?.accessToken, page_id, (res) => {
          formik.setValues({ ...res, originalPosition: res?.position });
        })
      );
    }

    if (!pages?.length || pages?.length < 2) {
      dispatch(get_pages(auth?.user?.accessToken, "page", success));
    } else {
      success(pages);
    }
  }, []);

  const formik = useFormik({
    initialValues: {
      page_id: "",
      description: "",
      position: "",
    },
    validationSchema,
    onSubmit: (values) => {
      if (pages?.length) {
        let flag = false;
        if (
          (page_id && values?.originalPosition != values?.position) ||
          !page_id
        )
          pages.filter((e) => {
            if (page_id) {
              if (e.position == values.position) {
                flag = true;
              }
            } else {
              if (
                e.page_id == values.page_id ||
                e.position == values.position
              ) {
                flag = true;
              }
            }
          });
        if (!flag) {
          if (page_id) {
            dispatch(edit_page(values, auth?.user?.accessToken, onSuccessEdit));
          } else dispatch(add_page(values, auth?.user?.accessToken, onSuccess));
        } else {
          errorAlert("Position already exists.");
        }
      } else {
        dispatch(add_page(values, auth?.user?.accessToken, onSuccess));
      }
    },
  });

  const onSuccessEdit = (e) => {
    dispatch(get_pages(auth?.user?.accessToken, "page"));
    successAlert("Page Edited successfully.");
    history.goBack();
  };
  const onSuccess = (e) => {
    successAlert("Page added successfully.");
    history.goBack();
  };
  const success = (e) => {
    if (!page_id) {
      formik.setFieldValue("page_id", Math.max(...e.map(item => item.page_id)) + 1);
    }
  };
  const changeHandler = (e) => {
    formik.handleChange(e);
  };

  return (
    <React.Fragment>
      <div className="container-fluid">
        <div className="row">
          <div className="left-side-panel">
            <LeftSideNavigation displayLink={1} />
          </div>
          <div className="super-admin-right-side-panel">
            <HomeReusableTopBarNavigation />
            <div className="super-admin-inside-right-side-panel">
              <div className="d-flex justify-content-between align-items-center pt-4 pb-3">
                <div className="f24_700_HelveticaNeue">Add Page</div>
              </div>
              <hr />
              <Form>
                <Row>
                  <Col md={4}>
                    <Form.Group className="pb-4">
                      <div className="f16-700 mr-2 my-2"> Page ID</div>
                      <TextField
                        id="page_id"
                        label="Page ID"
                        type="text"
                        variant="outlined"
                        className={`w-100`}
                        name="page_id"
                        // onChange={changeHandler}
                        value={formik.values.page_id}
                        disabled
                      />

                      {formik.errors.page_id && formik.touched.page_id ? (
                        <div className="pho_14_regular text-danger">
                          {formik.errors.page_id}
                        </div>
                      ) : null}
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col md={8}>
                    <Form.Group className="pb-4">
                      <div className="f16-700 mr-2 my-2"> Description</div>
                      <TextField
                        id="description"
                        label="Description"
                        type="text"
                        variant="outlined"
                        value={formik?.values?.description || ""}
                        className={`w-100`}
                        name="description"
                        onChange={changeHandler}
                      />

                      {formik.errors.description &&
                      formik.touched.description ? (
                        <div className="pho_14_regular text-danger">
                          {formik.errors.description}
                        </div>
                      ) : null}
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col md={4}>
                    <Form.Group className="pb-4">
                      <div className="f16-700 mr-2 my-2">Position</div>
                      <TextField
                        id="position"
                        label="Position"
                        type="number"
                        variant="outlined"
                        className={`w-100`}
                        value={formik?.values?.position || ""}
                        name="position"
                        onChange={changeHandler}
                      />
                      {formik.errors.position && formik.touched.position ? (
                        <div className="pho_14_regular text-danger">
                          {formik.errors.position}
                        </div>
                      ) : null}
                    </Form.Group>
                  </Col>
                </Row>
                <div className="py-4 d-flex align-items-center">
                  <Button
                    variant="outline-secondary"
                    className="btn-lg mr-4 px-5 btn150px"
                    type="button"
                    onClick={history.goBack}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="danger"
                    className="btn-lg px-5 btn150px"
                    type="button"
                    onClick={formik.handleSubmit}
                  >
                    Save
                  </Button>
                </div>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
export default Addpages;
